export var CRED_KEY = 'cwr_c';
export var SESSION_COOKIE_NAME = 'cwr_s';
export var USER_COOKIE_NAME = 'cwr_u';
export var CRED_RENEW_MS = 30000;
